import React from 'react';
import Seo from './common/Seo';

import CallToAction from "./common/CallToAction";
import Drawer from "./common/Drawer";
import PageTitle from "./common/PageTitle";
import Skills from "./home/Skills";
import { routeIds } from "./i18n/routes";
import { useI18n } from "./i18n/I18nContext";
import Members from "./team/Members";

function Team({route}) {
  const { pathFor, t } = useI18n();
  const title = t("pages.team.title");
  const description = t("pages.team.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="equipe" title={t("pages.team.heading")} text={t("pages.team.intro")} />,
    <Members />,
    <Skills />,
    <CallToAction id="contact" title={t("pages.team.ctaTitle")} text={t("pages.team.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <Drawer route={route} />
  ];
}

export default Team;
